import { render, staticRenderFns } from "./organization.vue?vue&type=template&id=79dc193e&"
import script from "./organization.vue?vue&type=script&lang=tsx&"
export * from "./organization.vue?vue&type=script&lang=tsx&"
import style0 from "./organization.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports